module.exports = __webpack_public_path__ + "static/media/Mini_BallBuy.011077fa.png";